<template>
  <div class="text-center">
    <v-snackbar
      v-model="showSnackbar"
      :timeout="timeout"
      top
      right
      shaped
      outlined
      :color="colorSnackbar"
      elevation="4"
    >
      <div class="d-flex align-center">
        <v-icon left :color="colorSnackbar" class="mr-3">
          {{ iconoSnackbar }}
        </v-icon>
        
        <strong class="texto-limpio">{{ mensajeSnackbar.toUpperCase() }}</strong>
      </div>

      <div class="snackbar-progress-bg">
        <div
          v-if="showSnackbar"
          class="snackbar-progress-bar"
          :style="{ 
            animationDuration: timeout + 'ms',
            backgroundColor: colorSnackbar 
          }"
        ></div>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="closeSnackbar" :color="colorSnackbar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      timeout: 4500, // Aquí controlas el tiempo de forma centralizada
      showSnackbar: false,
    };
  },
  computed: {
    ...mapGetters([
      'snackbarOK', 
      'mensajeSnackbar',
      'tipoSnackbar' 
    ]),
    
    colorSnackbar() {
      const tipo = this.tipoSnackbar ? this.tipoSnackbar.toUpperCase() : 'INFO';
      const colores = {
        ERROR: '#FF5252',     
        WARNING: '#FB8C00',   
        SUCCESS: '#4CAF50',   
        INFO: '#EE680B'       
      };
      return colores[tipo] || colores.INFO;
    },

    iconoSnackbar() {
      const tipo = this.tipoSnackbar ? this.tipoSnackbar.toUpperCase() : 'INFO';
      const iconos = {
        ERROR: 'mdi-alert-circle',
        WARNING: 'mdi-alert',
        SUCCESS: 'mdi-check-circle',
        INFO: 'mdi-information'
      };
      return iconos[tipo] || iconos.INFO;
    }
  },
  methods: {
    closeSnackbar() {
      this.showSnackbar = false;
    }
  },
  watch: {
    snackbarOK() {
      this.showSnackbar = false;
      this.$nextTick(() => {
        this.showSnackbar = true;
      });
    },
  },
};
</script>

<style scoped>
.texto-limpio {
  text-shadow: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
}

::v-deep .v-snack__wrapper {
  overflow: hidden !important; 
  position: relative !important;
}

::v-deep .v-snack__content {
  position: static !important;
  padding-bottom: 12px !important; 
}

.snackbar-progress-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px; 
  background-color: rgba(0, 0, 0, 0.04); 
}

.snackbar-progress-bar {
  height: 100%;
  width: 100%;
  opacity: 0.85; 
  /* AQUÍ ESTÁ LA MAGIA: Cambiamos de left a right */
  transform-origin: right; 
  animation: shrink-bar linear forwards;
}

@keyframes shrink-bar {
  0% { transform: scaleX(1); }
  100% { transform: scaleX(0); }
}
</style>